import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let MK体育 - MK(中国)一站式服务官方网站router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/newsdetails/:id',
      name: 'newsdetails',
      component: () => import('./views/NewsDetails.vue'),
    },
    {
      path: '/product/sensor',
      name: 'sensor',
      component: () => import('./views/product/sensor'),
    },
    {
      path: '/product/robot',
      name: 'robot',
      component: () => import('./views/product/robot'),
    },
    {
      path: '/product/robot/cicada',
      name: 'cicada',
      component: () => import('./views/product/info/cicada'),
    },
    {
      path: '/product/robot/cicadama',
      name: 'cicadama',
      component: () => import('./views/product/info/cicadama'),
    },
    {
      path: '/product/robot/ladybug',
      name: 'ladybug',
      component: () => import('./views/product/info/ladybug'),
    },

    {
      path: '/product/belt',
      name: 'belt',
      component: () => import('./views/product/belt'),
    },
    {
      path: '/product/belt/info',
      name: 'beltInfo',
      component: () => import('./views/product/info/belt'),
    },
    {
      path: '/product/sensor/stainless-steel-sensor',
      name: 'StainlessSteelSensor',
      component: () => import('./views/product/info/StainlessSteelSensor'),
    },
    {
      path: '/product/sensor/wzsensor',
      name: 'wzsensor',
      component: () => import('./views/product/info/wzsensor'),
    },
    {
      path: '/solution',
      name: 'solution',
      component: () => import('./views/solution/index')
    },
    {
      path: '/solution/colliery-corridor',
      name: 'CollieryCorridor',
      component: () => import('./views/solution/CollieryCorridor')
    },
    {
      path: '/solution/electricity',
      name: 'electricity',
      component: () => import('./views/solution/electricity')
    },
    {
      path: '/solution/cement',
      name: 'cement',
      component: () => import('./views/solution/cement')
    },
    {
      path: '/solution/port',
      name: 'port',
      component: () => import('./views/solution/port')
    },
    {
      path: '/solution/steel',
      name: 'steel',
      component: () => import('./views/solution/steel')
    },
    {
      path: '/about/company',
      name: 'company',
      component: () => import('./views/about/company'),
    },

    {
      path: '/about/consultation',
      name: 'consultation',
      component: () => import('./views/about/Consultation'),
    },
    {
      path:'/about/recruitment',
      name:'recruitment',
      component:()=>import("./views/about/recruitment")
    },
    {
      path: '/company/news',
      name: 'news',
      component: () => import('./views/news/index'),
    },
    {
      path: '/company/news/:id',
      name: 'info',
      component: () => import('./views/news/info'),
    },

  ]
})

// 判断是否需要登录权限 以及是否登录
MK体育 - MK(中国)一站式服务官方网站router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;

  // 兼容IE
  window.scrollTo(0, 0);
  // 判断是否需要登录权限
  if (to.matched.some(res => res.meta.requireAuth)) {
    // 判断是否登录
    if (sessionStorage.getItem('token')) {
      next()
    } else {
      // 没登录则跳转到登录界面
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})

export default MK体育 - MK(中国)一站式服务官方网站router
